/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ProductEventEntity;
(function (ProductEventEntity) {
    /**
     * id type of the record
     */
    var referenceType;
    (function (referenceType) {
        referenceType["FEATURE_ID"] = "featureId";
        referenceType["PRODUCT_VERSION"] = "productVersion";
        referenceType["HIERARCHY_ID"] = "hierarchyId";
        referenceType["ASSET"] = "asset";
    })(referenceType = ProductEventEntity.referenceType || (ProductEventEntity.referenceType = {}));
})(ProductEventEntity || (ProductEventEntity = {}));
